module.exports = __webpack_public_path__ + "img/loginExample.17419a3d.svg";